var html_classes = document.documentElement.classList;
html_classes.remove("no-js");
html_classes.add("js");